import { useEffect, useState } from 'react'
import { getAutoFillShortlisterCourses } from 'api/shortlister'

function parseAutofillCoursesResponse(res) {
	const courseRows = Array.isArray(res?.data?.[0])
		? res.data[0]
		: Array.isArray(res?.data)
			? res.data
			: []

	return courseRows.reduce(
		(acc, item) => {
			const degree = item.degree
			if (degree !== 'Postgraduate' && degree !== 'Undergraduate') return acc

			const isNode =
				item.label !== undefined || item.step_2 !== undefined
			if (isNode) {
				acc[degree].push({
					id: `${item.step_1}|${item.step_2}`,
					name: item.label || item.step_2,
					value: item.label || item.step_2,
					degree,
					step_1: item.step_1,
					step_2: item.step_2,
					specializations: item.specializations || [],
				})
			} else {
				acc[degree].push({
					id: item.id ?? `${item.course_name}-${degree}`,
					name: item.course_name,
					degree,
					value: item.course_name,
				})
			}
			return acc
		},
		{ Postgraduate: [], Undergraduate: [] },
	)
}

export function useShortlisterFilterAutofill() {
	const [autoFillUndergraduate, setAutoFillUndergraduate] = useState([])
	const [autoFillPostgraduate, setAutoFillPostgraduate] = useState([])
	const [statusCourse, setStatusCourse] = useState('idle')

	// Runs once on mount. `statusCourse` is intentionally NOT a dependency:
	// keying the effect on it made `setStatusCourse('loading')` re-run the
	// effect, whose cleanup cancelled the in-flight request and left the status
	// stuck at `loading`. The single auto-retry lives inside `load()` instead.
	useEffect(() => {
		let cancelled = false

		const load = async () => {
			setStatusCourse('loading')
			for (let attempt = 0; attempt < 2; attempt += 1) {
				try {
					const res = await getAutoFillShortlisterCourses()
					if (cancelled) return
					const parsed = parseAutofillCoursesResponse(res)
					setAutoFillUndergraduate(parsed.Undergraduate)
					setAutoFillPostgraduate(parsed.Postgraduate)
					setStatusCourse('success')
					return
				} catch {
					if (cancelled) return
					if (attempt === 1) {
						setStatusCourse('error')
					}
				}
			}
		}

		load().catch(() => {})

		return () => {
			cancelled = true
		}
	}, [])

	return {
		autoFillUndergraduate,
		autoFillPostgraduate,
		statusCourse,
	}
}
